import React from 'react';
import ReactDOM from 'react-dom';
import './episodes.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";


/* ---------------------RESOURCES--------------------- */
class Ep extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="longerPage container-fluid">
                <span class="topButtons"><button className="eButton"><Link to="/Episodes">Episodes</Link></button><button className="hButton"><Link to="/">Home</Link></button></span>

                
                {/*Titles*/}
                <div className="row">
                    <div className="title-wrapper col-12">
                        <h1 className="title">Season 2, Episode 6: National Hero Yi Sun-sin and Japanese Invasions</h1>
                        <h5 className="korean-title">시즌 2, 에피소드 6: 이순신</h5>
                    </div>
                </div>

                {/*VOCABULARY*/}
                <div class="vocabList">
<span class="italics">Listen to the episode <a target="_blank" href="https://anchor.fm/learn-korean-culture/episodes/S2--Episode-6-National-Hero-Yi-Sun-sin-and-Japanese-Invasions-e15ao86">here</a>!</span> <br></br>
<br></br>

{/* INTRO */}
조선 왕실 (joseon wang shil) – royalty of Joseon <br></br>
이번 주 (eeh bun joo) — this week <br></br>
이순신 장군 — Admiral Lee Soon Shin from the Joseon dynasty (pictured below) <br></br>
<img className="epPic-m" src="https://img2.quasarzone.com/editor/2021/06/06/f08bc350a15f38552e65ad2235732add.jpg"></img><br></br>
<br></br>


<br></br>
{/* JOSEON HISTORY */}
조선 (joseon) — a kingdom in the Korean peninsula that was born when general 이성계 started a coup d'etat and won (pictured below)<br></br>
<br></br>
<img className="epPic-sm" src="https://upload.wikimedia.org/wikipedia/commons/2/27/조선의_영토_확장.png"></img><br></br>
<br></br>
역사 (yeok sa) — history <br></br>
전기 (jeon gi) — early period <br></br>
후기 (hoo gi) — late period <br></br>
나눠진다 (nah nwu jin da) — to divide <br></br>
기준 (gi joon) – standard <br></br>

<br></br>
{/* IMJINWAERAN */}
임진왜란 (im jin wae ran) — a war that lasted from 1592 to 1598 (depicted below) <br></br>
<img className="epPic" src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Siege_of_Pyongyang_1593_02.jpg/800px-Siege_of_Pyongyang_1593_02.jpg"></img><br></br>
<br></br>
전쟁 (jun jaeng) — war <br></br>
7년 (chil yeon) — seven years <br></br>
일본 (il bon) — Japan <br></br>
지원군 (ji won goon) — supporting soldiers <br></br>
파병하다 (pa byeong ha da) — to dispatch <br></br>
명나라 (myeong na ra) — Ming dynasty of China <br></br>
패전 (pae jeon) — defeat <br></br>
후 (who) — afterwards <br></br>
내전 (nae jeon) — internal wars <br></br>
동아시아 (dong ah shi a) — east asia <br></br>
전체에게 (jeon chae ae gae) — as whole <br></br>
영향을 끼치다 (yeong hyang eul ggi chi da) — to have influence <br></br>

<br></br>
{/* MILITARY */}
도요토미 히데요시 (toyotomi hideyoshi) — a samurai that unified all of Japan (depicted below) <br></br>
<img className="epPic-m" src="https://magazineclonerepub.blob.core.windows.net/mcepub/2350/168584/image/dbdb3327-fe47-4721-b3b0-cd319c3f6af5.jpg"></img><br></br>
<br></br>
통일하다 (tong il ha da) — to unite/unify <br></br>
대규모 (dae gyu mo) — large scale <br></br>
군함 (goon ham) — warships <br></br>
공격하다 (gong gyeok ha da) – to attack <br></br>
거북선 (guh book seon) — a warship modelled after 판옥선 (panokseon), which was the typical warship used by the Joseon army (pictured below) <br></br>
<img className="epPic-m" src="http://img.segye.com/content/image/2019/03/30/20190330503032.jpg"></img><br></br>
<br></br>
거북 (guh book) — turtle <br></br>

<br></br>
{/* LEE SOON SHIN DEATH */}
대단한 (dae dan han) — amazing <br></br>
장군 (jang goon) — admiral <br></br>
명량해전 (myeong ryang hae jeon) — Battle of Myeongnyang <br></br>
노량해전 (noh ryang hae jeon) — the last naval battle of the entire war <br></br>
전략 (jeon ryak) — strategy <br></br>
덕분에 (duk boon ae) — thanks to <br></br>
후퇴하다 (hoo twae ha da) — to retreat <br></br>
총알에 맞다 (chong al ae mat da) — to be hit by a bullet <br></br>
싸움 (ssae oom) — the fight, battle  <br></br>
급하다 (geup ha da) — urgent and important <br></br>
죽다 (jook da) — to die <br></br>
말을 하지 말라 (mal eul ha ji mal la) — don’t tell <br></br>
유언 (yoo un) — last words <br></br>
숨을 거두다 (soom eul guh doo da) — to pass away (to die but in a more respectful way) <br></br>
아들 (ah deul) — son <br></br>
조카 (joh ka) — nephew  <br></br>

<br></br>
{/* CONCLUSION */}
유명하다 (yoo myeong ha da) — famous <br></br>
중요한 사람 (joong yo han sah ram) — important person <br></br>
At 세종대로 in the city of 서울 in South Korea, you can find a statue of admiral 이순신 (pictured below)<br></br>
<img className="epPic-m" src="https://images.chosun.com/resizer/nOz8VhWXYwE8Gv1LkkA1SPE6Ujw=/384x512/smart/cloudfront-ap-northeast-1.images.arcpublishing.com/chosun/HJPCZZKMKYY3XGUI5AO5DZSM6E.jpg"></img><br></br>
<br></br>
꼭 (kkok) — must, definitely <br></br>
찾아가보다 (chaz a ga bo da) – to go look for, to check out  <br></br>

                </div>
                <div className="row"><div className="col-12 spacer5"></div></div>
            </div>


        )
    }
}


/* -------------------------Variables------------------------- */
function App() {
    return (
        <div>
        <Ep></Ep>
        </div>
    );
}


  const Episode = () => (
    <div className='app'>
        <App />
    </div>
  );


export default Episode;